// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { translate } from '@tectonics/translate';
import { useSubmitting } from '@tectonics/prs/submitting';
import { getRedirectBackUrl, useOpenedIncomingPayment } from '@tectonics/prs/incoming-payment';
import { Button, Link } from '../../../../../commons/atoms';

export function BackToShopifyButton(): Node {
  const submitting = useSubmitting();
  const incomingPayment = useOpenedIncomingPayment();
  const redirectBackUrl = getRedirectBackUrl(incomingPayment);

  if (!redirectBackUrl) {
    return null;
  }

  return (
    <StyledButton
      flat
      as={Link}
      href={redirectBackUrl}
      type="outline"
      outlineColor="#2397d4"
      disabled={submitting}
      data-test-id="cancel"
    >
      <ButtonMessageWrapper>
        {translate('navigation.back')}
      </ButtonMessageWrapper>
    </StyledButton>
  );
}

const StyledButton = styled(Button)`
  font-size: 1.3rem;
  font-weight: 300;
  height: 60px;
  padding: 0 40px;
  border-width: 1px;
`;

const ButtonMessageWrapper = styled.span`
  height: 100%;
  display: inline-flex;
  align-items: center;
`;
